import React from "react";
import { NavLink } from "react-router-dom";
import "./nav.scss";

function Navigation() {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          Products &nbsp;
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-between w-100"
          id="navbarTogglerDemo01"
        >
          <div className="dropdown">
            <NavLink to="/fittingcomponents"
              className="nav-link"
            >
              Fitting Products
            </NavLink>

            {/* <div className="dropdown-menu">
              <NavLink className="dropdown-item" to="/brasscomponents">
                Brass Fittings
              </NavLink>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                S.S Fittings
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Conduit Fittings
              </a>
              <div className="dropdown-divider"></div>
              <NavLink className="dropdown-item" to="/pprinserts">
                PPR Inserts
              </NavLink>
            </div> */}
          </div>
          <div className="dropdown">
            <NavLink to="/earthingcomponents"
              className="nav-link"
            >
              Earthing Products
            </NavLink>

            {/* <div className="dropdown-menu">
              <a className="dropdown-item" href="#">
                Wall Mounting Flanges
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Eletrical Contact Pins
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Brackets
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Clamps
              </a>
            </div> */}
          </div>
          <div className="dropdown">
          <NavLink to="/mechanicalcomponents"
              className="nav-link"
            >
              Connectors
            </NavLink>

            {/* <div className="dropdown-menu">
              <a className="dropdown-item" href="#">
                Mechanical Connectors
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Neutral Bars
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Forged Connectors
              </a>
              <div className="dropdown-divider"></div>
              <a className="dropdown-item" href="#">
                Forged Clamps
              </a>
            </div> */}
          </div>
          {/* <div className="dropdown">
            <NavLink to="/plasticcomponents"
              className="nav-link"
              
            >
              Plastic Products
            </NavLink>

            
          </div> */}
          {/* <ul className="navbar-nav justify-content-between w-100">
            <li className="nav-item">
              <a className="nav-link" href="#">
                Fitting Components
              </a>
              <ul className="sub-menu">
                <li>
                  <a className="nav-link">Link 1</a>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Stamping Components
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Machined Components
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Plastic Components
              </a>
            </li>
          </ul> */}
        </div>
      </nav>
    </>
  );
}

export default Navigation;
